import { TableState } from "@tanstack/react-table";

export const getTableStateQueryParameters = (tableState: TableState) => {
    let filterState = "";
    if (tableState.pagination.pageIndex) {
        filterState += `&pageIndex=${tableState.pagination.pageIndex}`;
    }
    if (tableState.pagination.pageSize) {
        filterState += `&pageSize=${tableState.pagination.pageSize}`;
    }
    if (tableState.sorting) {
        filterState += `&sortBy=${JSON.stringify(tableState.sorting)}`;
    }
    if (tableState.columnFilters && tableState.columnFilters.length > 0) {
        filterState += `&tableFilters=${JSON.stringify(tableState.columnFilters)}`;
    }
    return filterState;
};
